export const environment = {
  production: false,
  projectName: "iotCore",
  // IDENTITY_LINK: `http://dev.leapfrogiot.com/services/predictive-maintenance`,
  // CORE_LINK: `http://dev.leapfrogiot.com/services/predictive-maintenance`,

  IDENTITY_LINK: `https://api.onstak.io/services/identity`,

  CORE_LINK: `https://api.onstak.io/services/iot-platform`,

  CORE_LINK_cdn: `https://api.onstak.io/services/iot-platform`,
  SOCKET_LINK: `https://api.onstak.io`,
  MQTT_LINK: `http://event-hub.onstak.io`,

  AI_ASSISTANT_API: `https://api-gsx.onstak.ai/services/ai-assistant`,
  AI_ASSISTANT_ASK: `https://api-gsx.onstak.ai/services/ai-assistant/ask`,

  auth: {
    authenticate: `/api/v2/accounts/user/authentication`,
    userExists: `/api/accounts/manage/user/exist`,
    recover: "/api/v2/accounts/user/forget-password",
    reset: "/api/v2/accounts/user/reset-password",
  },
  dash: {
    dashboard: `/api/v1/dashboards/`,
    workspace: `/api/v2/workspaces`,
    userExists: `/api/accounts/user/exists`,
    userDetails: `/api/accounts/user/details`,
    sheetsQuery: `/api/v2/sheets/query`,
    v1Sheets: `/api/v1/sheets`,
    v2Sheets: `/api/v2/sheets`,
    widgetsQuery: `/api/v2/widgets/query`,
    widgets: `/api/v2/widgets`,
    bookmarks: `/api/v1/dashboards/bookmarks`,
  },
  pluginsMaxNumberOfRecords: 20,
  socketUrlPath: "/services/streams",
  socketThingSubscribePath: "streams/device/subscribe",
  socketThingListenPath: "streams/telemetry/",
  GOOGLE_MAPS_API_KEY: "AIzaSyDTAnbYHkvbKFbYmWr10P918lcgqpwpDtk",
};
